import { FONT_SIZE, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivHeading = styled.div`
  font-size: ${FONT_SIZE.XL}px;
  padding: 32px 32px 16px 32px;
  ${mq.sp} {
    font-size: ${FONT_SIZE.LL}px;
    padding: 16px;
  }
`;
